import { configureStore } from '@reduxjs/toolkit';
import adminPayReducer from './admin-pay-slice';
import adminBillReducer from './admin-bill-slice';
import adminSubscriptionSlice from './admin-subs-slice';
import adminMemberReducer from './admin-member-slice';
import adminAppReducer from './admin-app-slice';

import memberBillReducer from './member-bill-slice';
import memberProfileReducer from './member-profile-slice';
import memberSubscriptionSlice from './member-subs-slice';

export default configureStore({
  reducer: {
    adminPay: adminPayReducer,
    adminBill: adminBillReducer,
    adminSubs: adminSubscriptionSlice,
    adminMember: adminMemberReducer,
    adminApp: adminAppReducer,

    memberBill: memberBillReducer,
    memberProfile: memberProfileReducer,
    memberSubs: memberSubscriptionSlice,
  }
});